import Vue from 'vue'
import { fetchNotificationHasNew, fetchNotificationUnreadCount } from '@/api/notification'
import { getToken } from '@/utils/auth'

export const notificationState = Vue.observable({
  unreadCount: 0,
  latestId: 0,
  hasNew: false,
  loading: false
})

export const setUnreadCount = (count) => {
  notificationState.unreadCount = Math.max(0, Number(count) || 0)
}

export const decrementUnreadCount = (count = 1) => {
  setUnreadCount(notificationState.unreadCount - (Number(count) || 0))
}

export const clearNotificationState = () => {
  notificationState.unreadCount = 0
  notificationState.latestId = 0
  notificationState.hasNew = false
  notificationState.loading = false
}

export const loadUnreadCount = async() => {
  if (!getToken()) {
    clearNotificationState()
    return 0
  }

  if (notificationState.loading) {
    return notificationState.unreadCount
  }

  notificationState.loading = true

  try {
    const count = await fetchNotificationUnreadCount()
    setUnreadCount(count)
    return count
  } finally {
    notificationState.loading = false
  }
}

export const pollNotificationHasNew = async() => {
  if (!getToken()) {
    clearNotificationState()
    return {
      has_new: false,
      unread_count: 0,
      latest_id: 0
    }
  }

  const result = await fetchNotificationHasNew(notificationState.latestId)
  notificationState.hasNew = result.has_new
  notificationState.latestId = result.latest_id
  setUnreadCount(result.unread_count)

  return result
}
